import { IdInput } from '../../lib/types/utils'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

interface SaveLanguageTestResponseRequest {
  questionId: number
  selectedAnswerId: number
}

export const saveLanguageTestResponse = ({
  id: submissionId,
  ...dto
}: IdInput<SaveLanguageTestResponseRequest>) =>
  restApiClient.url(constructApiUrl(API.languageTest.saveResponse.url, { submissionId })).post(dto)
